<div class="header">
  <div class="title">Chart Builder</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="addContactForm">
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Name</mat-label>
      <input matInput [formControlName]="'title'" required />
    </mat-form-field>
  </div>

  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Chart Type</mat-label>
      <mat-select [formControlName]="'chart_type'">
        <mat-option [value]="'bar'">Bar</mat-option>
        <mat-option [value]="'line'">Line</mat-option>
        <mat-option [value]="'horizontal-bar'">Horizontal Bar</mat-option>
        <mat-option [value]="'donut'">Donut</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Summary Type</mat-label>
      <mat-select [formControlName]="'summary_type'">
        <mat-option [value]="'total'">Count</mat-option>
        <mat-option [value]="'sum'">Sum</mat-option>
        <mat-option *ngIf="this.addContactForm.get('chart_type').value !== 'line'" [value]="'average'"
          >Average
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div
    class="flex flex-col gt-xs:flex-row"
    *ngIf="
      ['average', 'sum'].includes(
        this.addContactForm.get('summary_type').value && this.addContactForm.get('summary_type').value
      )
    "
  >
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Summary Field</mat-label>
      <mat-select [formControlName]="'summary_value'">
        <mat-option *ngFor="let field of fieldDefs" [value]="field.name">{{ field.label }} </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div
    class="flex flex-col gt-xs:flex-row"
    *ngIf="this.addContactForm.get('chart_type').value && this.addContactForm.get('chart_type').value !== 'line'"
  >
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>X-Axis</mat-label>
      <mat-select [formControlName]="'group_by'">
        <mat-option *ngFor="let field of fieldDefs" [value]="field.name">{{ field.label }} </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div
    class="flex flex-col gt-xs:flex-row"
    *ngIf="
      this.addContactForm.get('chart_type').value &&
      this.addContactForm.get('chart_type').value !== 'line' &&
      this.addContactForm.get('chart_type').value !== 'donut'
    "
  >
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Series</mat-label>
      <mat-select [formControlName]="'series_value'">
        <mat-option [value]=""></mat-option>
        <mat-option *ngFor="let field of fieldDefs" [value]="field.name">{{ field.label }} </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-col">
    <p class="text-lg font-medium">Custom filters for this chart</p>
    <p class="text-secondary">Filters here will override dashboard filters.</p>
    <mat-divider
      role="separator"
      class="mat-divider mt-8 mb-10 mat-divider-horizontal"
      aria-orientation="horizontal"
    ></mat-divider>
    <list-filter
      (filterSearchInput)="noop($event)"
      (projectFilters)="noop($event)"
      (filterChanged)="filterChanged($event)"
      [queryFilters]="parsedFilters"
      [savedFilter]="{}"
      [onlyList]="true"
      [inData]="data"
      listStyle="width: 100%"
    ></list-filter>
  </div>

  <!-- Body -->
  <div class="actions">
    <div class="formatting">
      <treo-message
        *ngIf="message"
        [appearance]="message.appearance"
        [showIcon]="message.showIcon"
        [type]="message.type"
        [@shake]="message.shake"
      >
        {{ message.content }}
      </treo-message>
    </div>
    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button type="button" (click)="discard()">
        <span>Cancel</span>
      </button>

      <!-- Send -->
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        type="submit"
        [disabled]="addContactForm.invalid"
        (click)="saveAndClose()"
      >
        <span>Save</span>
      </button>
    </div>
  </div>
</form>
